import React from 'react';
import { Modal } from '@qualtrics/ui-react';
import styles from './command-palette.scss';
import { RovingTabIndexContextProvider } from './context/rovingTabIndexContext/RovingTabIndexContext';
import { CommandPaletteModalContent } from './components/CommandPaletteModalContent';
import { CommandPaletteTrigger } from './components/CommandPaletteTrigger';
import { panes } from './config/groups';
import { VisibilityProvider } from './hooks/useVisibilityContext';
import { sendTractiveMetric } from '@qualtrics/page-metrics/lib/tractiveService';

export default function CommandPalette() {
  const [open, setOpen] = React.useState(false);

  const inputRef = React.useRef(null);

  // Toggle the menu when ⌘K is pressed
  React.useEffect(() => {
    const down = (e) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  React.useEffect(() => {
    if (open) {
      sendTractiveMetric({
        billingTeam: 'GW',
        eventName: 'CommandPalette.Open',
      });
    }
  }, [open]);

  const close = () => setOpen(false);

  return (
    <>
      <CommandPaletteTrigger setOpen={setOpen} />
      <Modal
        open={open}
        onOpenChange={setOpen}
        className={styles.commandPaletteModal}
        onClose={close}
        onDismiss={close}
        elementRefToFocusOnOpen={inputRef}
      >
        <VisibilityProvider panes={panes}>
          <RovingTabIndexContextProvider>
            <CommandPaletteModalContent inputRef={inputRef} open={open} />
          </RovingTabIndexContextProvider>
        </VisibilityProvider>
      </Modal>
    </>
  );
}

CommandPalette.propTypes = {};
